import { render, staticRenderFns } from "./ForgetPasswordForm.vue?vue&type=template&id=9d493f9a"
import script from "./ForgetPasswordForm.vue?vue&type=script&lang=js"
export * from "./ForgetPasswordForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports